import useFocus from "@/lib/hooks/interactions/other/useFocus";
import { AlertColorType } from "@/lib/main";
import { CSSProperties, PropsWithChildren } from "react";
import formStyle from "./formStyle.shared";

type Props = PropsWithChildren<{
  onClick?: () => void;
  value: string;
  disabled?: boolean;
  alertColor?: AlertColorType;
  selectRef: React.RefObject<HTMLSpanElement | null>;
}>;

export default function Select({
  children,
  onClick,
  value,
  disabled,
  alertColor,
  selectRef,
}: Props) {
  const { isFocused, onFocus, onBlur } = useFocus();

  const sharedStyle = formStyle({ value, isFocused, alertColor, disabled });
  const styles: CSSProperties = {
    ...sharedStyle,

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    height: "3rem",
    marginTop: "var(--spacing-xs)",
    padding: "0 var(--spacing-md)",

    fontSize: "var(--font-size-sm)",

    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  return (
    <span
      role="select"
      onClick={onClick}
      onFocus={onFocus}
      onBlur={onBlur}
      ref={selectRef}
      style={styles}
    >
      {children}
    </span>
  );
}
